import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export type History = {
  push: (to: string) => void;
};

export type RouteComponentProps = {
  location?: ReturnType<typeof useLocation>;
  params?: ReturnType<typeof useParams>;
  navigate?: ReturnType<typeof useNavigate>;
  history?: History;
};

export function withRouter(
  Component: React.FunctionComponent<RouteComponentProps>
) {
  function ComponentWithRouterProp(props: RouteComponentProps) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    const history = {
      push: (to: string) => {
        navigate(to);
      },
    };

    return (
      <Component
        {...props}
        location={location}
        params={params}
        navigate={navigate}
        history={history}
      />
    );
  }

  return ComponentWithRouterProp;
}
